import {useState} from 'react';
import {Button,Modal} from '@cap4/ui';
import {Trash2,Undo2} from 'lucide-react';
import {api,message} from '../../lib/api';
import {useQuery} from '../../lib/useQuery';
import type {Content} from '../../lib/types';
import {Notice,QueryState} from '../../app/components';
import {draftIds,restoredDraft} from './optimisticTrash';
import './trash.css';

export function DeleteDraftButton({onClick}:{onClick:()=>void}){
 return <button className="draft-trash-button" onClick={onClick}><Trash2 size={15} aria-hidden="true"/>Slet kladde</button>;
}
export function TrashConfirmation({item,onClose,onConfirm}:{item:Content;onClose:()=>void;onConfirm:()=>void}){
 const ids=draftIds(item);
 return <Modal title="Flyt kladde til papirkurven?" className="cap4publish-create-modal" overlayClassName="cap4publish-modal-overlay" onClose={onClose} onSubmit={event=>{event.preventDefault();onConfirm();}} submitLabel="Flyt til papirkurv" cancelLabel="Annuller">
  <p><strong>{item.title||'Uden titel'}</strong>{ids.length>1?` · ${ids.length} sprogversioner`:''}</p>
  <p>Du kan gendanne kladden i 30 dage. Derefter bliver den automatisk slettet permanent.</p>
 </Modal>;
}
type TrashMember={id:string;locale?:string;deletedAt:string;expiresAt:string;canRestore:boolean};
type TrashedDraft=TrashMember&{source:string;title:string;availableLocales?:string[];restoreIds?:string[];members?:TrashMember[]};
const date=(value:string)=>new Date(value).toLocaleString('da-DK',{day:'numeric',month:'long',year:'numeric',hour:'2-digit',minute:'2-digit'});
const expiry=(value:string)=>Date.parse(value)<=Date.now()?'Fristen er udløbet. Afventer automatisk sletning.':`Slettes permanent ${date(value)}`;
export function DraftTrashPanel({knowledge}:{knowledge:boolean}){
 const q=useQuery<{items:TrashedDraft[]}>('listTrashedDrafts',{kind:knowledge?'article':'social',groupTranslations:knowledge});
 const [busy,setBusy]=useState(''),[error,setError]=useState(''),[notice,setNotice]=useState('');
 async function restore(item:TrashedDraft){
  setBusy(`${item.source}:${item.id}`);setError('');setNotice('');
  const ids=item.restoreIds||[item.id];
  try{
   await api('restoreDraft',{source:item.source,...(ids.length>1?{ids}:{id:ids[0]})});
   ids.forEach(id=>restoredDraft(item.source,id));
   setNotice(item.members&&ids.length<item.members.length?'De tilgængelige sprogversioner er gendannet og ligger i oversigten igen.':'Kladden er gendannet og ligger i oversigten igen.');
  }
  catch(e){setError(message(e));}finally{setBusy('');}
 }
 return <div className="draft-trash-panel">
  <p className="muted">Slettede kladder kan gendannes i 30 dage. Derefter slettes de automatisk permanent.</p>
  {error&&<Notice error>{error}</Notice>}{notice&&<Notice>{notice}</Notice>}
  <QueryState {...q}>
   {q.data?.items.length?<ul className="draft-trash-list">{q.data.items.map(item=><li key={`${item.source}:${item.id}`}>
    <div><h2>{item.title}{(item.availableLocales||(item.locale?[item.locale]:[])).map(locale=><span key={locale} className="badge">{locale.toUpperCase()}</span>)}</h2>
     {item.members?.some(member=>member.deletedAt!==item.deletedAt)?item.members.map(member=><div key={member.id}><p>{member.locale?.toUpperCase()} · Slettet {date(member.deletedAt)}</p><p>{expiry(member.expiresAt)}</p></div>):<><p>Slettet {date(item.deletedAt)}</p><p>{expiry(item.expiresAt)}</p></>}
    </div>
    {item.canRestore&&<Button variant="secondary" icon={Undo2} disabled={!!busy} loading={busy===`${item.source}:${item.id}`} onClick={()=>restore(item)}>Gendan</Button>}
   </li>)}</ul>:!q.loading&&!q.error&&<div className="content-empty panel"><Trash2 size={28} aria-hidden="true"/><h3>Papirkurven er tom</h3><p>Slettede kladder vises her i 30 dage.</p></div>}
  </QueryState>
 </div>;
}
